<h3 mat-dialog-title>
    {{ params.title }}
</h3>

<mat-dialog-content class="py-3">
    {{ params.message }}
</mat-dialog-content>

<mat-dialog-actions align="center">
    <button mat-stroked-button color="primary" (click)="cancel()">
        {{ params.cancelButtonTxt }}
    </button>
    <button mat-raised-button color="primary" (click)="accept()">
        {{ params.acceptButtonTxt }}
    </button>
</mat-dialog-actions>
